import {createApp} from 'vue'
import App from './App.vue'
import router from '@/configure/router'
import store from '@/configure/store'
import VueParticles from 'vue-particles'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import '@/style/crudStyle.css';
import '@/style/baseSystemStyle.css'
import '@/style/selectUserKITStyle.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import uploader from 'vue-simple-uploader'
import 'vue-simple-uploader/dist/style.css'
import Cropper from "vue3-cropper";
import 'vue3-cropper/lib/vue3-cropper.css';
import '@/style/comingSoonStyle.css'
import '@/style/newCommonStyle.css'
import '@/style/selectUser.css'

const app = createApp(App)
app.use(router)
app.use(store)
app.use(VueParticles)
app.use(uploader)
app.use(Cropper)
app.use(ElementPlus, {
    locale: zhCn,
});
// 计算表格列表项宽度
function tableItemWidthCalculation(length) {
    return Math.ceil((length * 14 + 24 + 2) / 5) * 5;
}
app.config.globalProperties.$tableItemWidthCalculation = tableItemWidthCalculation;
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
app.mount('#app')
